module.exports = __webpack_public_path__ + "img/TT.9574aff3.svg";